export default {
  labels: {
    invoice: 'Faktura',
    on_site: 'Betal på stedet (kontant/kort)',
  },
};
